var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.429 14.774H.857a.857.857 0 0 0 0 1.714H13.43a.858.858 0 0 0 0-1.714ZM15.497 2.203 14.286.99a1.771 1.771 0 0 0-2.423 0L4.194 8.66a.571.571 0 0 0-.16.309l-.605 3.428a.583.583 0 0 0 .56.674h.102l3.429-.605a.582.582 0 0 0 .297-.16l7.669-7.669A1.714 1.714 0 0 0 16 3.414a1.737 1.737 0 0 0-.503-1.211Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.9024804c626d7f59102c44f39fadc33f.svg";
export { ForwardRef as ReactComponent };